<!--
 * Created by JackCui on 2021/12/16
 -->

<script>
  import {clickEventHandler} from '../utils/share'
  import Buttons from '../components/container/buttons/index.vue'
  import {parsing, ruleModelHandle} from '../utils/page-driven'

  const buttonTypeMap = {
    'button': {
      1: 'primary',
      2: 'plain',
      default: 'textPlain'
    },
    'button_group': {
      1: 'primaryGroup',
      default: 'plainGroup'
    }
  }

  export default {
    name: 'buttons-render',
    props: {
      node: Object,
      row: Object
    },
    inject: ['formData', 'store'],
    computed: {
      buttonList () {
        const {buttons} = this.node
        return this.buttonListHandle(buttons)
      }
    },
    render (h) {
      return (
        <div class="button-wrap">
          {
            [
              this.buttonRender(),
              this.operationRender()
            ]
          }
        </div>
      )
    },
    methods: {
      buttonRender () {
        const {maxLength, position, size, span} = this.node
        const operationLeftSlots = this.node?.slots?.['operation_left']
        return <div class="button-row">
          {
            this.buttonList.length
              ? <Buttons
                class="button-gallery"
                size={size}
                span={span}
                buttons={this.buttonList}
                position={position}
                maxLength={maxLength}
                on-button-click={this.buttonClickHandle}
              />
              : null
          }
          {operationLeftSlots && operationLeftSlots(this.$createElement)}
        </div>
      },
      operationRender () {
        const operationRightSlots = this.node?.slots?.['operation_right']
        return operationRightSlots && (
          <div class="operation-right">
            {
              operationRightSlots(this.$createElement)
            }
          </div>
        )
      },
      buttonRuleHandle (rule, varMap) {
        for (let v in rule) {
          if (!rule.hasOwnProperty(v)) {
            continue
          }
          const {ruleMode} = ruleModelHandle(v, rule)
          return !parsing({ruleMode, varMap})
        }
      },
      buttonClickHandle (button) {
        const {formData, row, store} = this
        const {query} = this.$route
        const {aPaaS_SequenceId: id} = row || {}
        const {permissionPointApiName, _objectApiName, objectApiName, layoutApiName} = button
        clickEventHandler({
          buttonItem: button,
          linkObjectModel: {
            layoutApiName,
            tenantType: store.tenantType,
            objectApiName: _objectApiName || objectApiName,
            operationApiName: permissionPointApiName
          },
          query: {
            c: query.c,
            id: id || query.id
          },
          formData,
          row: row || (Array.isArray(formData) ? {} : formData)
        })
      },
      buttonListHandle (buttons) {
        const {formData, row} = this
        return (buttons || []).map(v => {
          let _button = v
          // 合并props
          if (typeof _button.propsFn === 'function') {
            _button = Object.assign(
              {},
              _button,
              _button.propsFn.call(this, {
                buttonItem: _button,
                row,
                formData
              })
            )
          }

          const {
            styleShowType,
            apiName,
            type = 'button',
            style,
            size,
            hide,
            _rules,
            render,
            operateTip: tooltip,
            buttonList: btnList,
            __params: {_objectApiName, objectApiName: objApiName, layoutApiName, app},
            ...reset
          } = _button
          const objectApiName = _objectApiName || objApiName
          const buttonType = buttonTypeMap[type][styleShowType] || buttonTypeMap[type]['default']
          let buttonList = btnList
          let buttonHide = hide
          let name = _button.name
          if (Array.isArray(buttonList)) {
            buttonList = this.buttonListHandle(buttonList)
          }

          if (typeof buttonHide === 'function') {
            buttonHide = buttonHide({
              buttonItem: _button,
              row,
              formData
            })
          }

          // 按钮规则
          if (_rules) {
            buttonHide = this.buttonRuleHandle(
              _rules.ruleModelMap,
              {
                [objectApiName]: row || formData
              }
            )
          }

          if (typeof name === 'function') {
            name = name({formData, row})
          }

          return {
            ...reset,
            apiName,
            size: this.size || size,
            type: buttonType,
            spm: `${objectApiName}_${layoutApiName}_${apiName}`,
            hide: buttonHide,
            tooltip,
            buttonList,
            objectApiName: objApiName,
            _objectApiName,
            layoutApiName,
            tenantType: app,
            render: render
              ? () => render({
                buttonItem: _button,
                row,
                formData
              })
              : null,
            name
          }
        }).filter(v => !v.hide)
      }
    },
    components: {Buttons}
  }
</script>

<style lang="scss" scoped>
.button-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  .button-row {
    flex: 1;

    .button-gallery {
      display: inline-block;
    }
  }
}
</style>
